<template>
  <div class="container-fluid">
    <h2>Angebot</h2>
    <br/>
    <div class="btn-toolbar">
      <div class="btn-group">
        <button @click="reexportOffer" class="btn btn-secondary">Export wiederholen</button>
        <button @click="reworkOffer"   class="btn btn-secondary">Workflow wiederholen</button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md">
        <Address title="Kunde" :address="order.customer"/>
      </div>
      <div class="col-md">
        <Address title="Lieferanschrift" :address="order.deliver"/>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-header">Angebot</div>
          <div class="card-body">
            <div class="row">
              <div class="col"><b id="nrtitle">Angebots-Nr.:</b></div>
              <div class="col">{{ order.map_id }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Kunden-Nr.</b></div>
              <div class="col"><a href="#" @click="openCustomer()">{{ order.customer.map_id }}</a></div>
            </div>
            <div class="row">
              <div class="col"><b>Übermittelt:</b></div>
              <div class="col">{{ order.register }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Erstellt:</b></div>
              <div class="col">{{ order.created }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Lieferung:</b></div>
              <div class="col">{{ order.deliverdate }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Herkunft:</b></div>
              <div class="col">{{ order.source }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Vertreter:</b></div>
              <div class="col">{{ order.handid }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Netto-Summe:</b></div>
              <div class="col">{{ order.netto }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Prozess</b></div>
              <div class="col"><router-link :to="'/workflows/history/' + order.processId">{{ order.processId }}</router-link></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h4>Positionen:</h4>
    <b-table :items="order.positions" :fields="fields" @row-clicked="openArticle" striped hover>
      <template v-slot:cell(price)="data">
        {{ Number(data.item.price).toFixed(2) }}&nbsp;{{ data.item.currency }}
      </template>
      <template v-slot:cell(sum)="data">
        {{ Number(data.item.sum).toFixed(2) }}&nbsp;{{ data.item.currency }}
      </template>
    </b-table>
    <hr/>
    <div class="row">
      <div class="col-md">
        <h5>Kommentar:</h5><br/>
        <p>{{ order.comment }}</p>
      </div>
      <div v-if="order.extras" class="col-md">
        <h5>Parameter:</h5><br/>
        <table class="table table-striped">
            <tr v-for="(val,key) in order.extras" :key="key">
              <td valign="top"><b>{{ key }}</b></td>
              <td>
                <a v-if="val.startsWith('ts-image:')" target="_blank" :href="baseUrl + 'rest/data/extrafields/res/' + order.handid + '/' + val.substring(9)">
                  <img style="max-width:100%;max-height:250px;" :src="baseUrl + 'rest/data/extrafields/res/' + order.handid + '/' + val.substring(9)"/>
                </a>
                <span v-else>{{ val }}</span>
              </td>
            </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import config from '@/modules/config.js'
import offers from '@/modules/offers.js'
import Address from '@/components/documents/Address.vue'

export default {
  name: 'OrderView',
  components: {
    Address
  },
  data() {
    return {
      baseUrl: "",
      order: { customer: {} , deliver: {}, positions: []},
      positions: [],
      fields: [
        {label:"Pos.",key:"pos"},
        {label:"Artikel-Nr.",key:"article_nr"},
        {label:"Bezeichnung",key:"desc"},
        {label:"Menge",key:"count"},
        {label:"Einheit",key:"unit_desc"},
        {label:"Preis",key:"price"},
        {label:"Summe",key:"sum"},
      ]
    }
  },
  methods: {
    openArticle: function(row) {
      router.push({name: 'ArticleView',params:{articleid: row.article_id }});
    },
    openCustomer: function() {
      if (this.order.customer.map_id) {
        router.push({name: 'CustomerView',params:{customerid: this.order.customer.map_id }});
      }
    },
    reworkOffer: function() {
      if (confirm('Das aktuelle Angebot noch einmal Nachbearbeiten (E-Mail / Innendienst etc.)?')) {
        var self = this;
        offers.rework(this,this.order.id,function() {
          self.$bvToast.toast('Nachverarbeitung gestartet.',{ title: 'Angebot',variant: 'success'})
        })
      }
    },
    reexportOffer: function() {
      if (confirm('Das aktuelle Angebot noch einmal an die Warenwirtschaft übergebn?')) {
        var self = this;
        offers.reexport(this,this.order.id,function() {
          self.$bvToast.toast('Export gestartet.',{ title: 'Angebot',variant: 'success'})
        })
      }
    }
  },
  created: function() {
    this.baseUrl = config.baseUrl;
    var self = this;
    offers.load(this,this.$route.params.offerid,function(data) {
      console.log(data);
      self.order = data.value;
      self.positions = data.value.positions;
    })
  }
}
</script>
